import React, { Component } from 'react';
import { Table, Card, Row, Col ,Input, Form, Menu, Button, Comment, Tooltip, List, Typography, Divider, Select } from 'antd';
import styles from './index.module.less';
import menuData from './order-menu-data';
import NoticeLayout from '@/components/Notice'
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import DocList from '@/components/DocList'
import getFAQData from '../FAQ/mock-faq-data'
import getNoticeData from '../../notices/mock-list-data'
import faqMenuData from '../FAQ/faq-menu-data'

const mapStateToProps = (rootState) => {
  const user = rootState.user;
  return {
    currentRoute: rootState.router,
    order: rootState.order,
    isLogin: user.isLogin,
  };
};


class OrderComponent extends Component {
  constructor(props) {
    super(props);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
        if (err) {
            return;
        }
        dispatch.order.createOrder(values);
    });
  }

  render() {
    const { TextArea } = Input;
    const { Item: FormItem } = Form;;
    const { getFieldDecorator } = this.props.form;
    const {
      currentRoute,
      isLogin
    } = this.props;
    const location = this.props.order;
    if (!isLogin) {
      this.props.router.push('/signIn');
    }

    if (location.isSubmited) {
      dispatch.order.updatePath({
        itemPath: '我的工单'
      });
      dispatch.router.push(`/support/work_order`);
    }
   
    
    const onMenuClick = (type) => {
      if (type == 1) {
        dispatch.router.push(`/support/work_order?create=new`);
      } else if (type == 0){
        dispatch.router.push(`/support/work_order`);
      } 
    }
    const setMenuItemKeyPath = (itemPath) => {
      dispatch.order.updatePath({
        itemPath
      });
    }
    

    const getListItem = () => {
      if (location.isSubmited) {
        dispatch.order.clearSubmit();
      }
      const onListClick = (item) => {
        dispatch.router.push(`/support/work_order?orderId=${item.id}`);
      }
      const columns = [
        {
          title: '工单编号',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '工单内容',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '问题分类',
          dataIndex: 'field',
          key: 'field',
        },
        {
          title: '更新时间',
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          render: (text, record) => new Date(record.updatedAt).toLocaleString()
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: '操作',
          dataIndex: '',
          key: 'x',
          render: (text, record) => <a href="javascript:void(0);" onClick={()=>onListClick(record)}>查看</a>
        }
      ];
  
      return (
        <Table dataSource={this.props.order.personalOrderList} 
          columns={columns} 
          rowKey={'id'} 
          style={{margin:"20px 0px"}} 
        >
        </Table>
      ); 
    }
    
    const getCreateItem = () => {
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      };
      const tailFormItemLayout = {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 4},
        },
      };
      const initVal = this.props.order.orderType ? faqMenuData[1].children[this.props.order.orderType.split(',')[1]].title :'';
      return (
        <Card title='提交工单' headStyle={{backgroundColor:"#f5f6fa"}} style={{margin:"20px 0px"}}>
          <Form onSubmit={this.handleSubmit} className={styles.loginWrap} {...formItemLayout} >
            <FormItem label="问题分类" >
              {
                getFieldDecorator('field', {
                  rules: [
                    {
                      required: true,
                      message: ''
                    }
                  ],
                  initialValue: initVal,
                })(
                  <Select />
                )
              }
            </FormItem>
            <FormItem label="问题标题" >
                {
                  getFieldDecorator('title', {
                    rules: [
                      {
                        required: true,
                        message: ''
                      }
                    ]
                  })(
                    <Input
                      placeholder=""/>
                      
                  )
                }
            </FormItem>
            <FormItem label="问题描述" >
              {
                getFieldDecorator('description', {
                  rules: [
                    {
                      required: true,
                      message: ''
                    }
                  ]
                })(
                  <TextArea className={styles.inputArea}
                    placeholder="" />
                )
              }
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                  提交工单
              </Button>
            </FormItem>
          </Form>
        </Card>
      )
    }
    
    

    
    const getShowItem = () => {
      const { Title, Paragraph, Text } = Typography;
      const orderInfo = this.props.order.orderInfo;
      const commentData = () => {
        if (this.props.order.orderInfo.comment) {
          return this.props.order.orderInfo.comment.map(
            elem => {
              return {
                ...elem,
                datetime: (
                  <Tooltip
                    title={new Date(orderInfo.createdAt).toLocaleString()}
                  >
                    <span>
                      {new Date(orderInfo.createdAt).toLocaleString()}
                    </span>
                  </Tooltip>
                ),
              }
            });
        }  
      } 
        
      
      return (
        <div>
          <Card style={{margin:"20px 0px"}}>
            <Typography>
              <Title>{orderInfo.status}</Title>
              <Paragraph>
                <Text strong>
                  问题标题:
                </Text>
              </Paragraph>
              <Paragraph>
                <Text strong>
                  {orderInfo.title}
                </Text>
              </Paragraph>
              <Divider />
              <Paragraph>
                工单编号:
                <Text strong>
                  {orderInfo.id}
                </Text>
                &nbsp;&nbsp;&nbsp;&nbsp;
                提交时间:
                <Text strong>
                  {new Date(orderInfo.createdAt).toLocaleString()}
                </Text>
              </Paragraph>
            </Typography>
          </Card>
  
          <Card title="沟通记录 "  style={{margin:"20px 0px"}}>
            <List
              className="comment-list"
              itemLayout="horizontal"
              dataSource={commentData()}
              renderItem={item => (
                <li>
                  <Comment
                    author={item.username}
                    content={item.comment}
                    datetime={item.datetime}
                  />
                </li>
              )}
          />
          </Card>
        </div>
      )
    }
    
  
    

    const getQuestionItem = () => {
      const onQuestionClick = (elem) => {
        dispatch.router.push(`/support/work_order?create=${elem}&notice=true`);
      };
      const data = faqMenuData[1].children;
      return (
        <Card title='工单问题分类' headStyle={{backgroundColor:"#f5f6fa"}} style={{margin:"20px 0px"}}>
          <List
            grid={{ gutter: 16, column: 4 }}
            dataSource={data}
            
            renderItem={(item) => (
              <List.Item>
                <Card bodyStyle={{backgroundColor:"#f5f6fa"}}>
                  <div style={{display:"flex", justifyContent:"space-between"}} >
                    <p style={{margin:"5px 0px"}}>{item.title}</p><Button onClick={() => (onQuestionClick(item.index))} style={{border:"1px solid #28a3ef"}}>提问</Button>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        </Card>
      )
    }

    const getNoticeItem = () => {
      
      const onNoticeClick = (item) => {
        dispatch.router.push(`/notices?docId=${item.id}`);
      }
      const onFAQClick = (item) => {
        dispatch.router.push(`/support/FAQ?docId=${item.id}`);
      }
      const location = this.props.order;
      const getSelectedData = () => {
        let dataSelect = (location.orderType === '' || location.orderType === '0') ? getFAQData : getFAQData.filter(elem => elem.type === location.orderType);
        
        return dataSelect;
      }
      const onCreateClick = () => {
        dispatch.router.push(`/support/work_order?create=${location.orderType}`);
      };
      const initVal = this.props.order.orderType ? faqMenuData[1].children[this.props.order.orderType.split(',')[1]].title :'';
      return (
        <div style={{ border:"1px solid #e8e8e8"}}>
          <Row style={{ height:"800px"}}>
            <Col span={8} style={{ height:"100%"}}>
            <Card style={{ height:"100%", borderWidth:"0px 1px 0px 0px"}} > 
              <Menu mode="inline" style={{margin:"20px 0px", height:"100%",borderWidth:"0px"}}>
                <Menu.Item key="1" onClick={onCreateClick}>
                  {initVal}
                </Menu.Item>
              </Menu>
              </Card>
            </Col>
            <Col span={16}>
              <Card title='请关注以下公告和热点(如需提交工单，请选择左侧分类)' bordered={false} >
                <Card title='公告' headStyle={{backgroundColor:"#f5f6fa"}} bordered={false} style={{margin:"20px 0px"}}>
                  <DocList
                    dataSource={getNoticeData()}
                    listType = 'notices'
                    onClick = {onNoticeClick}
                  />
                </Card>
                <Card title='FAQ' headStyle={{backgroundColor:"#f5f6fa"}} bordered={false}>
                  <DocList
                    dataSource={getSelectedData()}
                    listType = 'FAQ'
                    onClick = {onFAQClick}
                  />
                </Card>
              </Card>
            </Col>
          </Row>
        </div>
      )
    }
    const renderItem = () =>  {
      const typeList = {
        create: getCreateItem,
        list: getListItem,
        order: getShowItem,
        question: getQuestionItem,
        notice: getNoticeItem
      }
      return (typeList[this.props.order.routerType] || getListItem)();
    };
    return (
      <NoticeLayout
        menuData={menuData}
        setMenuItemKeyPath={setMenuItemKeyPath}
        setDocType={onMenuClick}
        itemPath={location.itemPath}
        currentRoute={currentRoute}
        sideType='工单'
        titleName='工单'>
        {renderItem()}
      </NoticeLayout>
    )
  }
}
const component = Form.create()(OrderComponent);

export default connect(mapStateToProps)(component);
